import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="167dc18a">
      <g id="c171d75a">
        <g id="f016d1d3">
          <g id="d018f3f4">
            <g id="250e11a0">
              <path
                id="e43d3eb9"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3273 24C10.3273 22.4757 10.5804 21.0144 11.0323 19.6437L3.12344 13.6043C1.58205 16.7339 0.713623 20.2603 0.713623 24C0.713623 27.7365 1.58099 31.2608 3.12024 34.3883L11.0248 28.3371C10.5772 26.9728 10.3273 25.5168 10.3273 24Z"
                fill="#FBBC05"
              />
              <path
                id="f5f00a0c"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.2136 10.1333C27.525 10.1333 30.65 11.08 33 13L39.5 6.5C35.3341 2.87333 30.1954 0.533325 24.2136 0.533325C14.9269 0.533325 6.9454 5.84426 3.12344 13.6043L11.0323 19.6437C12.8546 14.112 18.0491 10.1333 24.2136 10.1333Z"
                fill="#EB4335"
              />
              <path
                id="27a772e1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.2136 37.8667C18.0491 37.8667 12.8546 33.888 11.0323 28.3563L3.12344 34.3947C6.9454 42.1557 14.9269 47.4667 24.2136 47.4667C29.9455 47.4667 35.4178 45.4315 39.5249 41.6181L32.0178 35.8144C29.8996 37.1488 27.2323 37.8667 24.2136 37.8667Z"
                fill="#34A853"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponent;
